export default __webpack_public_path__ + "static/media/Horns of the Endless Sands.5b20ace3.jpg";